import {ip_back , api_key} from '../constants/appConstants';

const API_URL = ip_back + '/api/companias';

export const cargarCompanias = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/listar`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error('Error al listar companias');
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const obtenerCompania = async (id) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(`${API_URL}/obtener_compania?id=${id}`, {        
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) throw new Error(`Error al obtener el cliente: ${id}`);
      return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const crearCompania = async (formData, telefonos, correos, creador, ramos) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "ruc" : formData.ruc, "nombre" : formData.nombre, "creador" : creador,  "telefonos": telefonos, "correos": correos, "direccion" : formData.direccion, "ramos" : ramos}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarCompania = async (formData, editor, id) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ "id": id, "nombre" : formData.nombre, "editor" : editor, "direccion" : formData.direccion}),
      });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarCompania = async (id, editor) => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(`${API_URL}/eliminar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "id" : id, "editor" : editor}),
        });
          return response;
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
};

export const agregarTelefono = async (formData, id, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/agregar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "compania" : id, "telefono" : formData.telefono, "creador" : creador , "descripcion" : formData.descripcion}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarTelefono = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id": formData.id, "telefono": formData.telefono, "editor": editor, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarTelefono = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_telefono`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const agregarCorreo = async (formData, id, creador) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/agregar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "compania": id, "correo": formData.correo, "creador": creador, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const actualizarCorreo = async (formData, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/actualizar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id": formData.id, "correo": formData.correo, "editor": editor, "descripcion": formData.descripcion }),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};

export const eliminarCorreo = async (id, editor) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const response = await fetch(`${API_URL}/eliminar_correo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': api_key,
          Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ "id" : id, "editor" : editor}),
    });
      return response;
  } catch (error) {
    console.error('Error al hacer la solicitud:', error);
  }
};